var isArrayish = function(obj) {
  return !obj || typeof obj == "string" ? !1 : obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};
export {
  isArrayish as i
};
//# sourceMappingURL=index.js.map
